import React from 'react'
import AppLayout from './AppLayout'
import { NavLink } from 'react-router-dom'


function HRMSLayout({children}) {
    return (
        
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-3'>
                        <div className="list-group">
                            <NavLink to={"/hrms/company/dashboard"} className="list-group-item list-group-item-action">Company</NavLink>
                            <NavLink to={"/hrms/company/location"} className="list-group-item list-group-item-action">Company Location</NavLink>
                            <NavLink to={"/project/dashboard"} className="list-group-item list-group-item-action">Project</NavLink>
                            <NavLink to={"/task/dashboard"} className="list-group-item list-group-item-action">Task</NavLink>
                            <NavLink to={"/employee/dashboard"} className="list-group-item list-group-item-action">Employee</NavLink>
                            <NavLink to={"/attendance/dashboard"} className="list-group-item list-group-item-action">Attendance</NavLink>
                            <NavLink to="/leave-request/dashboard" className="list-group-item list-group-item-action">Leave Request</NavLink>
                            <NavLink to="/work-report/dashboard" className="list-group-item list-group-item-action">Work Report</NavLink>
                            <NavLink to="/holiday-list/dashboard" className="list-group-item list-group-item-action">Holiday List</NavLink>
                            <NavLink to="/employee/print-id-card" className="list-group-item list-group-item-action">Print ID Card</NavLink>
                        </div>
                    </div>
                    <div className='col-md-9'>
                        {children}
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default HRMSLayout